import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import taskServices from './tasks.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const get_tasks = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.TASKS_LOADER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? `/api/app/Formal_Funciones/` : '/api/app/Funcional_Funciones/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: params
    // });
    const resp = await taskServices.getTasks(params, iType);
    dispatch({
      type: actions.GET_TASKS,
      payload: {
        tasks: resp.data.data,
        tasksLength: resp.data.count
      }
    });
    dispatch({
      type: actions.TASKS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.TASKS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.TASKS_LOADER,
      payload: false
    });
  }
}

export const get_tasks_descriptors = (params) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.TASKS_LOADER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get('/api/app/Funcional_Funciones_filtrado_unidad_organizativa/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: params
    // });
    const resp = await taskServices.getTasksDescriptors(params);
    dispatch({
      type: actions.GET_TASKS,
      payload: {
        tasks: resp.data.data,
        tasksLength: resp.data.count
      }
    });
    dispatch({
      type: actions.TASKS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.TASKS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.TASKS_LOADER,
      payload: false
    });
  }
}

export const saveTask = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.TASKS_SAVE_LOADER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? `/api/app/Formal_Funciones/` : '/api/app/Funcional_Funciones/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await taskServices.saveTask(req, iType);
    const { tasks, tasksLength } = getState().tasks;
    const aTasks = [...tasks, resp.data];
    dispatch({
      type: actions.GET_TASKS,
      payload: {
        tasks: aTasks,
        tasksLength: tasksLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.TASKS_SAVE_LOADER,
      payload: false
    });
  }
}

export const editTask = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.TASKS_SAVE_LOADER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Funciones/${id}/` : `/api/app/Funcional_Funciones/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await taskServices.editTask(id, req, iType);
    const { tasks, tasksLength } = getState().tasks;
    tasks[index] = resp.data;

    dispatch({
      type: actions.GET_TASKS,
      payload: {
        tasks: tasks,
        tasksLength: tasksLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.TASKS_SAVE_LOADER,
      payload: false
    });
  }
}

export const deleteTask = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.TASKS_LOADER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Funciones/${id}` : `/api/app/Funcional_Funciones/${id}`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await taskServices.deleteTask(id, iType);
    const { tasks, tasksLength } = getState().tasks;
    tasks.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_TASKS,
      payload: {
        tasks: tasks,
        tasksLength: tasksLength -1
      }
    });
    dispatch({
      type: actions.TASKS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.TASKS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.TASKS_LOADER,
      payload: false
    });
  }
}
